module.exports = __webpack_public_path__ + "img/profess5.1d68b405.png";